import React from 'react';

const PopupLoginForm = ({ 
    loginUsername, 
    setLoginUsername, 
    loginPassword, 
    setLoginPassword, 
    loggingIn, 
    handleLogin 
}) => {
    return (
        <div className="popup-login-container">
            <div className="popup-login-form">
                <div className="popup-login-header">
                    <h2 className="popup-login-title">NslMail Login</h2>
                </div>
                
                <div className="popup-login-form-group">
                    <label className="popup-login-label">
                        Username:
                    </label>
                    <input 
                        type="text"
                        value={loginUsername}
                        onChange={(e) => setLoginUsername(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                        className="popup-login-input"
                        disabled={loggingIn}
                    />
                </div>
                
                <div className="popup-login-form-group">
                    <label className="popup-login-label">
                        Password:
                    </label>
                    <input 
                        type="password"
                        value={loginPassword}
                        onChange={(e) => setLoginPassword(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                        className="popup-login-input"
                        disabled={loggingIn}
                    />
                </div>
                
                <div className="popup-login-form-group">
                    <a 
                        href="https://nslmail.com/forgot-password" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="popup-login-forgot-link"
                    >
                        Forgot password?
                    </a>
                </div>
                
                <div className="popup-login-button-container">
                    <button 
                        onClick={handleLogin}
                        disabled={loggingIn}
                        className="popup-login-button"
                    >
                        {loggingIn ? 'Logging in...' : 'Login'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopupLoginForm;